import { TradeMethodsPage } from 'features/trade-methods';

export const AdminTradeMethodsPage: React.FC = () => <TradeMethodsPage />;
